import { SharedConstants } from "../../constants/shared.constants";
export const GROUPS_NOT_SET_IN_METADATA_MSG = "Recipient groups are not set in the step metadata, please contact administrator.";
export const GROUPS_STRING_ARRAY_FORM_CONTROL = "groupsStringArray";
export const JOB_ID_FORM_CONTROL = "jobId";
export const MODULE_ID_FORM_CONTROL = "moduleId";
export const PERSONAL_DETAILS_HEADER_PLACEHOLDER = "Personal details";
export const PROFESSIONAL_BODY_HEADER_PLACEHOLDER = "Professional body details";
export const RELATIVE_DETAILS_HEADER_PLACEHOLDER = "Relative's details";
export const EMPLOYERS_DETAILS_HEADER_PLACEHOLDER = "Employer's details";
export const STREET_ADDRESS_HEADER_PLACEHOLDER = "Street address";
export const POSTAL_ADDRESS_HEADER_PLACEHOLDER = "Postal address";
export const NAME_TEXT_PLACEHOLDER = "Name";
export const SURNAME_TEXT_PLACEHOLDER = "Surname";
export const HOMEPHONE_TEXT_PLACEHOLDER = "Home telephone";
export const TELEPHONE_TEXT_PLACEHOLDER = "Work telephone";
export const CELLPHONE_TEXT_PLACEHOLDER = "Cellphone";
export const EMAIL_TEXT_PLACEHOLDER = "Email";
export const ORGANISATION_TEXT_PLACEHOLDER = "Organisation";
export const CLIENT_VAT_NO_PLACEHOLDER = "Client VAT number";
export const DESIGNATION_TEXT_PLACEHOLDER = "Designation";
export const PROFESSIONAL_BODY_TEXT_PLACEHOLDER = "Professional body";
export const PROFESSIONAL_BODY_REGNO_TEXT_PLACEHOLDER = "Professional body registration number";
export const MARITAL_STATUS_TEXT_PLACEHOLDER = "Marital status";
export const RELATIVES_FULL_NAME_TEXT_PLACEHOLDER = "Relative's full name";
export const RELATIVES_CONTACT_NUMBER_TEXT_PLACEHOLDER = "Relative's contact number";
export const RELATIVES_ADDRESS_TEXT_PLACEHOLDER = "Relative's address";
export const EMPLOYMENT_STATUS_TEXT_PLACEHOLDER = "Employment status";
export const EMPLOYERS_NAME_TEXT_PLACEHOLDER = "Employer's name";
export const EMPLOYERS_CONTACT_NUMBER_TEXT_PLACEHOLDER = "Employer's contact number";
export const EMPLOYERS_ADDRESS_TEXT_PLACEHOLDER = "Employer's address";
export const ID_NUMBER_TEXT_PLACEHOLDER = "ID Number";
export const PASSPORT_NUMBER_TEXT_PLACEHOLDER = "Passport Number";
export const GENDER_TEXT_PLACEHOLDER = "Gender";
export const DISABILITY_TEXT_PLACEHOLDER = "Disability";
export const MISSING_LOOKUPS = "Lookups not found or not set";
export const STREET_ADDRESS_TEXT_PLACEHOLDER = "Street address";
export const POSTAL_ADDRESS_TEXT_PLACEHOLDER = "Postal address";
export const SUBURB_TEXT_PLACEHOLDER = "Suburb";
export const CITY_TEXT_PLACEHOLDER = "City";
export const PROVINCE_TEXT_PLACEHOLDER = "Province";
export const COUNTRY_TEXT_PLACEHOLDER = "Country";
export const CODE_TEXT_PLACEHOLDER = "Code";
export const INVALID_RECIPIENT_MSG = "The loaded recipient is invalid, please contact system administrator.";
export const SACAP_REGISTRATION_NUMBER_FORM_CONTROL = "sacapRegistrationNumber";
export const SACAP_REGISTRATION_NUMBER_VERIFIED_FORM_CONTROL = "sacapRegistrationNumberVerified";
export const SACAP_REGISTRATION_LABEL = "SACAP registration number";
export const SACAP_VERIFICATION_BUTTON_LABEL = "Verify with SACAP";
export const ID_FORM_CONTROL = "id";
export const NAME_FORM_CONTROL = "name";
export const SURNAME_FORM_CONTROL = "surname";
export const HOMEPHONE_FORM_CONTROL = "homePhone";
export const TELEPHONE_FORM_CONTROL = "telephone";
export const CELLPHONE_FORM_CONTROL = "cellphone";
export const EMAIL_FORM_CONTROL = "email";
export const ORGANISATION_FORM_CONTROL = "organisation";
export const CLIENT_VAT_NO_CONTROL = "clientVatNumber";
export const DESIGNATION_FORM_CONTROL = "designation";
export const PROFESSIONAL_BODY_FORM_CONTROL = "professionalBody";
export const MARITAL_STATUS_FORM_CONTROL = "maritalStatus";
export const RELATIVE_FULL_NAME_FORM_CONTROL = "relativesFullName";
export const RELATIVE_CONTACT_NUMBER_FORM_CONTROL = "relativesContactNumber";
export const RELATIVE_ADDRESS_FORM_CONTROL = "relativesAddress";
export const EMPLOYMENT_STATUS_FORM_CONTROL = "employmentStatus";
export const EMPLOYERS_NAME_FORM_CONTROL = "employersName";
export const EMPLOYERS_CONTACT_NUMBER_FORM_CONTROL = "employersContactNumber";
export const EMPLOYERS_ADDRESS_FORM_CONTROL = "employersAddress";
export const ID_NUMBER_FORM_CONTROL = "idNumber";
export const PROFESSIONAL_BODY_REGISTRATION_NUMBER_FORM_CONTROL = "professionalBodyRegNum";
export const PASSPORT_NUMBER_FORM_CONTROL = "passportNumber";
export const GENDER_FORM_CONTROL = "gender";
export const DISABILITY_FORM_CONTROL = "disability";
export const ADDRESS_FORM_CONTROL = "streetAddress";
export const SUBURB_FORM_CONTROL = "streetSuburb";
export const CITY_FORM_CONTROL = "streetCity";
export const PROVINCE_FORM_CONTROL = "streetProvince";
export const COUNTRY_FORM_CONTROL = "streetCountry";
export const CODE_FORM_CONTROL = "streetCode";
export const POSTAL_ADDRESS_FORM_CONTROL = "postalAddress";
export const POSTAL_SUBURB_FORM_CONTROL = "postalSuburb";
export const POSTAL_CITY_FORM_CONTROL = "postalCity";
export const POSTAL_PROVINCE_FORM_CONTROL = "postalProvince";
export const POSTAL_COUNTRY_FORM_CONTROL = "postalCountry";
export const POSTAL_CODE_FORM_CONTROL = "postalCode";
export const SAME_AS_STREET_PLACEHOLDER = "Same as street address";
export const MODULE_ID_PLACEHOLDER = "moduleId";
export const COMPONENT_NAME = "recipientFormComponent";
export const SELECT_CONTACT_PERSON_PLACEHOLDER = "Select contact person";
export const DEFAULT_LABEL = "Select recipient";
export const ADD_DEFAULT_RECIPIENT_LABEL = "Add recipient";
export const FORM_CONTROL_NAME = "recipientFormControl";
export const FILTER_STRING = "All";
export const INVALID_REQUIRED_FIELDS_ERR_MSG = "Invalid required field object in the metadata";
export const GROUP_NAME_PLACEHOLDER = "groupName";
export const REQUIRED_FIELDS_KEY = "requiredFields";
export const PLEASE_SELECT_AN_OPTION = "Please select an option";
export const SACAP_REGISTRATION_HEADER = "SACAP verification";
export const validationMessage = {
    sacapRegistrationNumber: {
        sacapRegistrationNumber: "Please enter registration number and verify before continuing."
    },
    name: {
        name: "Please enter name.",
        maxlength: `Name ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
    },
    surname: {
        surname: "Please enter surname.",
        maxlength: `Surname ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
    },
    telephone: {
        telephone: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE,
        maxlength: `Telephone ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
    },
    homePhone: {
        homePhone: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE,
        maxlength: `Homephone ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
    },
    cellphone: {
        cellphone: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE,
        maxlength: `Cellphone ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
    },
    organisation: {
        organisation: "Please enter organisation name.",
        maxlength: `Organisation ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
    },
    gender: {
        gender: "Please select a gender.",
    },
    disability: {
        disability: "Please select your disability status.",
    },
    passportNumber: {
        passportNumber: "Please enter your passport number.",
    },
    clientVatNumber: {
        clientVatNumber: "Please enter the client's VAT number.",
        maxlength: `clientVatNumber ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    },
    designation: {
        designation: "Please enter designation.",
        maxlength: `Designation ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
    },
    professionalBody: {
        professionalBody: "Please enter professional body.",
        maxlength: `Professional Body ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "500")}`,
    },
    professionalBodyRegNum: {
        professionalBodyRegNum: "Please enter the professional body's registration number.",
        maxlength: `ProfessionalBody ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    },
    maritalStatus: {
        maritalStatus: "Please select your marital status.",
    },
    relativesFullName: {
        relativesFullName: "Please enter your relative's full name.",
    },
    relativesContactNumber: {
        relativesContactNumber: "Please enter your relative's contact number.",
    },
    relativesAddress: {
        relativesAddress: "Please enter your relative's address.",
    },
    employmentStatus: {
        employmentStatus: "Please select your employment status.",
    },
    employersName: {
        employersName: "Please enter your employer's name.",
    },
    employersContactNumber: {
        employersContactNumber: "Please enter your employer's number.",
    },
    employersAddress: {
        employersAddress: "Please enter your employer's address.",
    }, idNumber: {
        IdNumber: "Please enter your ID number.",
        maxlength: `ID number ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
    },
    email: {
        email: SharedConstants.EMAIL_VALIDATION_MESSAGE,
        maxlength: `Email ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
    },
    streetAddress: {
        streetAddress: "Please enter address.",
        maxlength: `Street Address ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
    },
    streetSuburb: {
        streetSuburb: "Please enter suburb.",
        maxlength: `Street Suburb ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    },
    streetCity: {
        streetCity: "Please enter city.",
        maxlength: `Street City ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
    },
    streetProvince: {
        streetProvince: "Please select a province.",
        maxlength: `Street Province ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
    },
    postalCode: {
        postalCode: "Please enter a postal code.",
        maxlength: `Postal Code ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
    },
    streetCountry: {
        streetCountry: "Please select a country.",
        maxlength: `Street Country ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
    },
    streetCode: {
        streetCode: "Please enter a street code.",
        maxlength: `Street Code ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
    },
    postalAddress: {
        postalAddress: "Please enter a postal address.",
        maxlength: `Postal Address ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
    },
    postalSuburb: {
        postalSuburb: "Please enter suburb.",
        maxlength: `Postal Suburb ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    },
    postalCity: {
        postalCity: "Please enter a city.",
        maxlength: `Postal City ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
    },
    postalProvince: {
        postalProvince: "Please select a province.",
        maxlength: `Postal Province ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
    },
    postalCountry: {
        postalCountry: "Please select a country.",
        maxlength: `Postal Country ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
    },
    groups: "Please select a group."
};
export const GROUPS_HEADER_PLACEHOLDER = "Groups";
export const GROUPS_TEXT_PLACEHOLDER = "Groups";
export const GROUPS_FORM_CONTROL = "groups";
export const LOOKUP_NAME = "RecipientGroup";
export const ERR_HANDLER_OBJ_NAME = "recipients group";
export const EXTERNAL_PLACEHOLDER = "External";
export var ControlStatus;
(function (ControlStatus) {
    ControlStatus["enable"] = "enable";
    ControlStatus["disable"] = "disable";
})(ControlStatus || (ControlStatus = {}));
export const DEFAULT_REQUIRED_FIELDS = [
    { name: "name", visible: true, required: true },
    { name: "surname", visible: true, required: true },
    { name: "homePhone", visible: true, required: false },
    { name: "telephone", visible: true, required: false },
    { name: "cellphone", visible: true, required: false },
    { name: "email", visible: true, required: true },
    { name: "idNumber", visible: false, required: false },
    { name: "organisation", visible: true, required: false },
    { name: "clientVatNumber", visible: false, required: false },
    { name: "designation", visible: true, required: false },
    { name: "maritalStatus", visible: false, required: false },
    { name: "professionalBody", visible: false, required: false },
    { name: "professionalBodyRegNum", visible: false, required: false },
    { name: "relativesFullName", visible: false, required: false },
    { name: "relativesContactNumber", visible: false, required: false },
    { name: "relativesAddress", visible: false, required: false },
    { name: "employmentStatus", visible: false, required: false },
    { name: "employersName", visible: false, required: false },
    { name: "employersContactNumber", visible: false, required: false },
    { name: "employersAddress", visible: false, required: false },
    { name: "postalAddress", visible: true, required: true },
    { name: "postalCity", visible: true, required: true },
    { name: "postalCode", visible: true, required: true },
    { name: "postalCountry", visible: true, required: true },
    { name: "postalProvince", visible: true, required: true },
    { name: "postalSuburb", visible: true, required: true },
    { name: "streetAddress", visible: true, required: true },
    { name: "streetCity", visible: true, required: true },
    { name: "streetCode", visible: true, required: true },
    { name: "streetCountry", visible: true, required: true },
    { name: "streetProvince", visible: true, required: true },
    { name: "streetSuburb", visible: true, required: true },
    { name: "passportNumber", visible: true, required: false },
    { name: "Gender", visible: true, required: false },
    { name: "Disabled", visible: true, required: false },
];
